import { render, staticRenderFns } from "./notificationHighlight.vue?vue&type=template&id=a21756d8"
import script from "./notificationHighlight.vue?vue&type=script&lang=js"
export * from "./notificationHighlight.vue?vue&type=script&lang=js"
import style0 from "./notificationHighlight.vue?vue&type=style&index=0&id=a21756d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports